import { graphql } from '../__generated__/gql';

export const GET_ALL_INSULATIONS = graphql(/* GraphQL */ `
  query Insulations($assetId: Int!) {
    allInsulations(assetId: $assetId) {
      insulationId
      circuitNumber
      referenceNumber
      description
      materials
      heatTracing
      status
      comments
      updatedAt
      updatedBy
      tarJobs {
        jobId
      }
    }
  }
`);

export const GET_JOB_INSULATIONS = graphql(/* GraphQL */ `
  query JobInsulations($jobId: Int!) {
    insulationsByJobId(jobId: $jobId) {
      insulationId
      circuitNumber
      referenceNumber
      description
      materials
      heatTracing
      status
      comments
      updatedAt
      updatedBy
      tarJobs {
        jobId
      }
    }
  }
`);

export const CREATE_INSULATION = graphql(/* GraphQL */ `
  mutation CreateInsulation($input: InsulationInput!) {
    createInsulation(input: $input) {
      insulationId
    }
  }
`);

export const UPDATE_INSULATION = graphql(/* GraphQL */ `
  mutation UpdateInsulation($input: InsulationInput!) {
    updateInsulation(input: $input) {
      insulationId
    }
  }
`);

export const LINK_INSULATION_JOBS = graphql(/* GraphQL */ `
  mutation LinkInsulationJobs($insulationId: Int!, $jobIds: [Int]!) {
    linkInsulationJobs(insulationId: $insulationId, jobIds: $jobIds) {
      insulationId
    }
  }
`);

export const REMOVE_INSULATION = graphql(/* GraphQL */ `
  mutation RemoveInsulation($insulationId: Int!) {
    removeInsulation(insulationId: $insulationId)
  }
`);
